import {put, takeLatest, call} from 'redux-saga/effects';
import {toast} from 'react-toastify';
import {get} from 'lodash';
import {
  fetchUnitsRequest,
  fetchUnitsSuccess,
  fetchUnitsError,
  fetchCategoriesRequest,
  fetchCategoriesSuccess,
  fetchCategoriesError,
  fetchCategorySourcesRequest,
  fetchCategorySourcesSuccess,
  fetchCategorySourcesError,
  createCategoryRequest,
  createCategorySuccess,
  createCategoryError,
  updateCategoryRequest,
  updateCategorySuccess,
  updateCategoryError,
  removeCategoryRequest,
  removeCategorySuccess,
  removeCategoryError,
  createCategorySourceRequest,
  createCategorySourceSuccess,
  createCategorySourceError,
  updateCategorySourceRequest,
  updateCategorySourceSuccess,
  updateCategorySourceError,
  removeCategorySourceRequest,
  removeCategorySourceSuccess,
  removeCategorySourceError,
  createUnitRequest,
  createUnitSuccess,
  createUnitError,
  updateUnitRequest,
  updateUnitSuccess,
  updateUnitError,
  removeUnitRequest,
  removeUnitSuccess,
  removeUnitError,
  fetchInputTableFieldsRequest,
  fetchInputTableFieldsSuccess,
  fetchInputTableFieldsError,
  createInputTableFieldRequest,
  createInputTableFieldSuccess,
  createInputTableFieldError,
  updateInputTableFieldRequest,
  updateInputTableFieldSuccess,
  updateInputTableFieldError,
  removeInputTableFieldRequest,
  removeInputTableFieldSuccess,
  removeInputTableFieldError,
  fetchInputTableDataRequest,
  fetchInputTableDataSuccess,
  fetchInputTableDataError,
  createInputTableDataRequest,
  createInputTableDataSuccess,
  createInputTableDataError,
  updateInputTableDataRequest,
  updateInputTableDataSuccess,
  updateInputTableDataError,
  removeInputTableDataRequest,
  removeInputTableDataSuccess,
  removeInputTableDataError,
  fetchCategorySourceRequest,
  fetchCategorySourceSuccess,
  fetchCategorySourceError,
} from './index';
import {
  fetchUnits,
  fetchCategories,
  fetchCategorySources,
  createCategory,
  updateCategory,
  removeCategory,
  createCategorySource,
  updateCategorySource,
  removeCategorySource,
  createUnit,
  updateUnit,
  removeUnit,
  fetchInputTableFields,
  createInputTableField,
  updateInputTableField,
  removeInputTableField,
  fetchInputTableData,
  createInputTableData,
  updateInputTableData,
  removeInputTableData,
  fetchCategorySource,
} from './api';

export const sagaActions = {
  FETCH_CATEGORIES: 'FETCH_CATEGORIES',
  CREATE_CATEGORY: 'CREATE_CATEGORY',
  UPDATE_CATEGORY: 'UPDATE_CATEGORY',
  REMOVE_CATEGORY: 'REMOVE_CATEGORY',
  FETCH_CATEGORY_SOURCES: 'FETCH_CATEGORY_SOURCES',
  CREATE_CATEGORY_SOURCE: 'CREATE_CATEGORY_SOURCE',
  UPDATE_CATEGORY_SOURCE: 'UPDATE_CATEGORY_SOURCE',
  REMOVE_CATEGORY_SOURCE: 'REMOVE_CATEGORY_SOURCE',
  FETCH_UNITS: 'FETCH_UNITS',
  CREATE_UNIT: 'CREATE_UNIT',
  UPDATE_UNIT: 'UPDATE_UNIT',
  REMOVE_UNIT: 'REMOVE_UNIT',
  FETCH_INPUT_TABLE_FIELDS: 'FETCH_INPUT_TABLE_FIELDS',
  CREATE_INPUT_TABLE_FIELD: 'CREATE_INPUT_TABLE_FIELD',
  UPDATE_INPUT_TABLE_FIELD: 'UPDATE_INPUT_TABLE_FIELD',
  REMOVE_INPUT_TABLE_FIELD: 'REMOVE_INPUT_TABLE_FIELD',
  FETCH_INPUT_TABLE_DATA: 'FETCH_INPUT_TABLE_DATA',
  CREATE_INPUT_TABLE_DATA: 'CREATE_INPUT_TABLE_DATA',
  UPDATE_INPUT_TABLE_DATA: 'UPDATE_INPUT_TABLE_DATA',
  REMOVE_INPUT_TABLE_DATA: 'REMOVE_INPUT_TABLE_DATA',
  FETCH_CATEGORY_SOURCE: 'FETCH_CATEGORY_SOURCE',
};

function* fetchUnitsSaga({payload}) {
  const {values} = payload;
  try {
    yield put(fetchUnitsRequest());
    const result = yield call(fetchUnits, values);
    if (!result.error) {
      yield put(
        fetchUnitsSuccess({
          data: result.data.data,
          page: values.page,
          pageSize: values.pageSize,
          totalPages: result.data.totalPages,
          totalRecords: result.data.totalRecords,
          sortOn: '',
          sortDir: '',
        })
      );
    } else if (result.error) {
      toast.error(result.error);
      yield put(
        fetchUnitsSuccess({
          data: [],
          page: values.page,
          pageSize: values.pageSize,
          totalPages: 1,
          totalRecords: 0,
          sortOn: '',
          sortDir: '',
        })
      );
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(fetchUnitsError(message));
    } else {
      toast.error(e.error);
      yield put(fetchUnitsError(e.error));
    }
  }
}

function* fetchCategoriesSaga({payload}) {
  const {values} = payload;
  try {
    yield put(fetchCategoriesRequest());
    const result = yield call(fetchCategories, values);
    if (!result.error) {
      yield put(
        fetchCategoriesSuccess({
          data: result.data.data,
          page: values.page,
          pageSize: values.pageSize,
          totalPages: result.data.totalPages,
          totalRecords: result.data.totalRecords,
          sortOn: '',
          sortDir: '',
        })
      );
    } else if (result.error) {
      toast.error(result.error);
      yield put(
        fetchCategoriesSuccess({
          data: [],
          page: values.page,
          pageSize: values.pageSize,
          totalPages: 1,
          totalRecords: 0,
          sortOn: '',
          sortDir: '',
        })
      );
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(fetchCategoriesError(message));
    } else {
      toast.error(e.error);
      yield put(fetchCategoriesError(e.error));
    }
  }
}

function* fetchCategorySourcesSaga({payload}) {
  const {categoryId, values} = payload;
  try {
    yield put(fetchCategorySourcesRequest());
    const result = yield call(fetchCategorySources, categoryId, values);
    if (!result.error) {
      yield put(
        fetchCategorySourcesSuccess({
          data: result.data.data,
          category: result.data.category,
          page: values.page,
          pageSize: values.pageSize,
          totalPages: result.data.totalPages,
          totalRecords: result.data.totalRecords,
          sortOn: '',
          sortDir: '',
        })
      );
    } else if (result.error) {
      toast.error(result.error);
      yield put(
        fetchCategorySourcesSuccess({
          data: [],
          page: values.page,
          pageSize: values.pageSize,
          totalPages: 1,
          totalRecords: 0,
          sortOn: '',
          sortDir: '',
        })
      );
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(fetchCategorySourcesError(message));
    } else {
      toast.error(e.error);
      yield put(fetchCategorySourcesError(e.error));
    }
  }
}

function* createCategorySaga({payload}) {
  const {values} = payload;
  try {
    yield put(createCategoryRequest());
    const result = yield call(createCategory, values);
    if (!result.error) {
      toast.success(result.message);
      yield put(createCategorySuccess(result));
    } else if (result.error) {
      toast.error(result.error);
      yield put(createCategoryError(result.error));
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(createCategoryError(message));
    } else {
      toast.error(e.error);
      yield put(createCategoryError(e.error));
    }
  }
}

function* updateCategorySaga({payload}) {
  const {categoryId, values} = payload;
  try {
    yield put(updateCategoryRequest());
    const result = yield call(updateCategory, categoryId, values);
    if (!result.error) {
      toast.success(result.message);
      yield put(updateCategorySuccess(result));
    } else if (result.error) {
      toast.error(result.error);
      yield put(updateCategoryError(result.error));
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(updateCategoryError(message));
    } else {
      toast.error(e.error);
      yield put(updateCategoryError(e.error));
    }
  }
}

function* removeCategorySaga({payload}) {
  const {categoryId, values} = payload;
  try {
    yield put(removeCategoryRequest());
    const result = yield call(removeCategory, categoryId, values);
    if (!result.error) {
      toast.success(result.message);
      yield put(removeCategorySuccess(result));
    } else if (result.error) {
      toast.error(result.error);
      yield put(removeCategoryError(result.error));
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(removeCategoryError(message));
    } else {
      toast.error(e.error);
      yield put(removeCategoryError(e.error));
    }
  }
}

function* createCategorySourceSaga({payload}) {
  const {categoryId, values} = payload;
  try {
    yield put(createCategorySourceRequest());
    const result = yield call(createCategorySource, categoryId, values);
    if (!result.error) {
      toast.success(result.message);
      yield put(createCategorySourceSuccess(result));
    } else if (result.error) {
      toast.error(result.error);
      yield put(createCategorySourceError(result.error));
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(createCategorySourceError(message));
    } else {
      toast.error(e.error);
      yield put(createCategorySourceError(e.error));
    }
  }
}

function* updateCategorySourceSaga({payload}) {
  const {categoryId, sourceId, values} = payload;
  try {
    yield put(updateCategorySourceRequest());
    const result = yield call(
      updateCategorySource,
      categoryId,
      sourceId,
      values
    );
    if (!result.error) {
      toast.success(result.message);
      yield put(updateCategorySourceSuccess(result));
    } else if (result.error) {
      toast.error(result.error);
      yield put(updateCategorySourceError(result.error));
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(updateCategorySourceError(message));
    } else {
      toast.error(e.error);
      yield put(updateCategorySourceError(e.error));
    }
  }
}

function* removeCategorySourceSaga({payload}) {
  const {categoryId, sourceId, values} = payload;
  try {
    yield put(removeCategorySourceRequest());
    const result = yield call(
      removeCategorySource,
      categoryId,
      sourceId,
      values
    );
    if (!result.error) {
      toast.success(result.message);
      yield put(removeCategorySourceSuccess(result));
    } else if (result.error) {
      toast.error(result.error);
      yield put(removeCategorySourceError(result.error));
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(removeCategorySourceError(message));
    } else {
      toast.error(e.error);
      yield put(removeCategorySourceError(e.error));
    }
  }
}

function* createUnitSaga({payload}) {
  const {values} = payload;
  try {
    yield put(createUnitRequest());
    const result = yield call(createUnit, values);
    if (!result.error) {
      toast.success(result.message);
      yield put(createUnitSuccess(result));
    } else if (result.error) {
      toast.error(result.error);
      yield put(createUnitError(result.error));
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(createUnitError(message));
    } else {
      toast.error(e.error);
      yield put(createUnitError(e.error));
    }
  }
}

function* updateUnitSaga({payload}) {
  const {unitId, values} = payload;
  try {
    yield put(updateUnitRequest());
    const result = yield call(updateUnit, unitId, values);
    if (!result.error) {
      toast.success(result.message);
      yield put(updateUnitSuccess(result));
    } else if (result.error) {
      toast.error(result.error);
      yield put(updateUnitError(result.error));
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(updateUnitError(message));
    } else {
      toast.error(e.error);
      yield put(updateUnitError(e.error));
    }
  }
}

function* removeUnitSaga({payload}) {
  const {unitId, values} = payload;
  try {
    yield put(removeUnitRequest());
    const result = yield call(removeUnit, unitId, values);
    if (!result.error) {
      toast.success(result.message);
      yield put(removeUnitSuccess(result));
    } else if (result.error) {
      toast.error(result.error);
      yield put(removeUnitError(result.error));
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(removeUnitError(message));
    } else {
      toast.error(e.error);
      yield put(removeUnitError(e.error));
    }
  }
}

function* fetchInputTableFieldsSaga({payload}) {
  const {sourceId, values} = payload;
  try {
    yield put(fetchInputTableFieldsRequest());
    const result = yield call(fetchInputTableFields, sourceId, values);
    if (!result.error) {
      yield put(
        fetchInputTableFieldsSuccess({
          data: result.data.data,
          source: result.data.source,
          staticConfigFields: result.data.staticConfigFields,
          units: result.data.units,
          page: values.page,
          pageSize: values.pageSize,
          totalPages: result.data.totalPages,
          totalRecords: result.data.totalRecords,
          sortOn: '',
          sortDir: '',
        })
      );
    } else if (result.error) {
      toast.error(result.error);
      yield put(
        fetchInputTableFieldsSuccess({
          data: [],
          page: values.page,
          pageSize: values.pageSize,
          totalPages: 1,
          totalRecords: 0,
          sortOn: '',
          sortDir: '',
        })
      );
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(fetchInputTableFieldsError(message));
    } else {
      toast.error(e.error);
      yield put(fetchInputTableFieldsError(e.error));
    }
  }
}

function* createInputTableFieldSaga({payload}) {
  const {sourceId, values} = payload;
  try {
    yield put(createInputTableFieldRequest());
    const result = yield call(createInputTableField, sourceId, values);
    if (!result.error) {
      toast.success(result.message);
      yield put(createInputTableFieldSuccess(result));
    } else if (result.error) {
      toast.error(result.error);
      yield put(createInputTableFieldError(result.error));
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(createInputTableFieldError(message));
    } else {
      toast.error(e.error);
      yield put(createInputTableFieldError(e.error));
    }
  }
}

function* updateInputTableFieldSaga({payload}) {
  const {sourceId, fieldId, values} = payload;
  try {
    yield put(updateInputTableFieldRequest());
    const result = yield call(updateInputTableField, sourceId, fieldId, values);
    if (!result.error) {
      toast.success(result.message);
      yield put(updateInputTableFieldSuccess(result));
    } else if (result.error) {
      toast.error(result.error);
      yield put(updateInputTableFieldError(result.error));
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(updateInputTableFieldError(message));
    } else {
      toast.error(e.error);
      yield put(updateInputTableFieldError(e.error));
    }
  }
}

function* removeInputTableFieldSaga({payload}) {
  const {sourceId, fieldId, values} = payload;
  try {
    yield put(removeInputTableFieldRequest());
    const result = yield call(removeInputTableField, sourceId, fieldId, values);
    if (!result.error) {
      toast.success(result.message);
      yield put(removeInputTableFieldSuccess(result));
    } else if (result.error) {
      toast.error(result.error);
      yield put(removeInputTableFieldError(result.error));
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(removeInputTableFieldError(message));
    } else {
      toast.error(e.error);
      yield put(removeInputTableFieldError(e.error));
    }
  }
}

function* fetchInputTableDataSaga({payload}) {
  const {sourceId, values} = payload;
  try {
    yield put(fetchInputTableDataRequest());
    const result = yield call(fetchInputTableData, sourceId, values);
    if (!result.error) {
      yield put(
        fetchInputTableDataSuccess({
          data: result.data.data,
          page: values.page,
          pageSize: values.pageSize,
          totalPages: result.data.totalPages,
          totalRecords: result.data.totalRecords,
          sortOn: '',
          sortDir: '',
        })
      );
    } else if (result.error) {
      toast.error(result.error);
      yield put(
        fetchInputTableDataSuccess({
          data: [],
          page: values.page,
          pageSize: values.pageSize,
          totalPages: 1,
          totalRecords: 0,
          sortOn: '',
          sortDir: '',
        })
      );
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(fetchInputTableDataError(message));
    } else {
      toast.error(e.error);
      yield put(fetchInputTableDataError(e.error));
    }
  }
}

function* createInputTableDataSaga({payload}) {
  const {sourceId, values} = payload;
  try {
    yield put(createInputTableDataRequest());
    const result = yield call(createInputTableData, sourceId, values);
    if (!result.error) {
      toast.success(result.message);
      yield put(createInputTableDataSuccess(result));
    } else if (result.error) {
      toast.error(result.error);
      yield put(createInputTableDataError(result.error));
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(createInputTableDataError(message));
    } else {
      toast.error(e.error);
      yield put(createInputTableDataError(e.error));
    }
  }
}

function* updateInputTableDataSaga({payload}) {
  const {sourceId, dataId, values} = payload;
  try {
    yield put(updateInputTableDataRequest());
    const result = yield call(updateInputTableData, sourceId, dataId, values);
    if (!result.error) {
      toast.success(result.message);
      yield put(updateInputTableDataSuccess(result));
    } else if (result.error) {
      toast.error(result.error);
      yield put(updateInputTableDataError(result.error));
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(updateInputTableDataError(message));
    } else {
      toast.error(e.error);
      yield put(updateInputTableDataError(e.error));
    }
  }
}

function* removeInputTableDataSaga({payload}) {
  const {sourceId, dataId, values} = payload;
  try {
    yield put(removeInputTableDataRequest());
    const result = yield call(removeInputTableData, sourceId, dataId, values);
    if (!result.error) {
      toast.success(result.message);
      yield put(removeInputTableDataSuccess(result));
    } else if (result.error) {
      toast.error(result.error);
      yield put(removeInputTableDataError(result.error));
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(removeInputTableDataError(message));
    } else {
      toast.error(e.error);
      yield put(removeInputTableDataError(e.error));
    }
  }
}

function* fetchCategorySourceSaga({payload}) {
  const {categoryId, sourceId, values} = payload;
  try {
    yield put(fetchCategorySourceRequest());
    const result = yield call(
      fetchCategorySource,
      categoryId,
      sourceId,
      values
    );
    if (!result.error) {
      yield put(fetchCategorySourceSuccess(result.data));
    } else if (result.error) {
      toast.error(result.error);
      yield put(
        fetchCategorySourceSuccess({
          data: null,
        })
      );
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(fetchCategorySourceError(message));
    } else {
      toast.error(e.error);
      yield put(fetchCategorySourceError(e.error));
    }
  }
}

function* rootSagas() {
  yield takeLatest(sagaActions.FETCH_UNITS, fetchUnitsSaga);
  yield takeLatest(sagaActions.FETCH_CATEGORIES, fetchCategoriesSaga);
  yield takeLatest(
    sagaActions.FETCH_CATEGORY_SOURCES,
    fetchCategorySourcesSaga
  );
  yield takeLatest(sagaActions.CREATE_CATEGORY, createCategorySaga);
  yield takeLatest(sagaActions.UPDATE_CATEGORY, updateCategorySaga);
  yield takeLatest(sagaActions.REMOVE_CATEGORY, removeCategorySaga);

  yield takeLatest(
    sagaActions.CREATE_CATEGORY_SOURCE,
    createCategorySourceSaga
  );
  yield takeLatest(
    sagaActions.UPDATE_CATEGORY_SOURCE,
    updateCategorySourceSaga
  );
  yield takeLatest(
    sagaActions.REMOVE_CATEGORY_SOURCE,
    removeCategorySourceSaga
  );

  yield takeLatest(sagaActions.CREATE_UNIT, createUnitSaga);
  yield takeLatest(sagaActions.UPDATE_UNIT, updateUnitSaga);
  yield takeLatest(sagaActions.REMOVE_UNIT, removeUnitSaga);

  yield takeLatest(
    sagaActions.FETCH_INPUT_TABLE_FIELDS,
    fetchInputTableFieldsSaga
  );
  yield takeLatest(
    sagaActions.CREATE_INPUT_TABLE_FIELD,
    createInputTableFieldSaga
  );
  yield takeLatest(
    sagaActions.UPDATE_INPUT_TABLE_FIELD,
    updateInputTableFieldSaga
  );
  yield takeLatest(
    sagaActions.REMOVE_INPUT_TABLE_FIELD,
    removeInputTableFieldSaga
  );

  yield takeLatest(sagaActions.FETCH_INPUT_TABLE_DATA, fetchInputTableDataSaga);
  yield takeLatest(
    sagaActions.CREATE_INPUT_TABLE_DATA,
    createInputTableDataSaga
  );
  yield takeLatest(
    sagaActions.UPDATE_INPUT_TABLE_DATA,
    updateInputTableDataSaga
  );
  yield takeLatest(
    sagaActions.REMOVE_INPUT_TABLE_DATA,
    removeInputTableDataSaga
  );

  yield takeLatest(sagaActions.FETCH_CATEGORY_SOURCE, fetchCategorySourceSaga);
}

export default rootSagas;
